import React from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";

export default function DecoSelect({ labelId, label, value, onChange, menuItems, isError = false }) {
  return (
    <FormControl fullWidth>
      <InputLabel id={labelId}>{label}</InputLabel>
      <Select
        labelId={labelId}
        value={value || ""}
        label={label}
        onChange={onChange}
        error={isError}
      >
        {menuItems.map((item) => (
          <MenuItem key={item} value={item}>
            {item}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
